/**
 * @generated SignedSource<<e01b7e9d4ff78e2a71aae03ffec6526c>>
 * @relayHash 27271e908fc653aab3a7bfff83bea97c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f1ff210ea23bda65c41f458b9c78a910e7eeedfc5d0cbc2ccbd924a13ef0291

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraCalendarEmbedSpaAppQuery } from './JiraCalendarEmbedSpaAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraCalendarEmbedSpaAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8f1ff210ea23bda65c41f458b9c78a910e7eeedfc5d0cbc2ccbd924a13ef0291",
    "metadata": {},
    "name": "JiraCalendarEmbedSpaAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
